module.exports = __webpack_public_path__ + "img/success-tick.1c82fd76.png";